// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__lA1pV","dropdown__footer":"dropdown_dropdown__footer__Nl6Y9"};